export default __webpack_public_path__ + "static/media/right.efdf7ab2.svg";